import { EpicPolicy } from '../tower/Domain';

export const DocumentDomainTypeClientUploaded = 'Client Uploaded';
export const DocumentDomainTypeAnalytics = 'Analytics';

export interface Document {
  documentDomainId: number;
  documentDomainName: string;
  documentSourceId: number;
  documentSourceName: string;
  documentTypeId: number;
  documentTypeName: string;
  accountId?: number;
  accountName?: string;
  policyId?: number;
  policyDescription?: string;
  documentId: string; // UUID string from Document.DocumentID column
  analyticsTypeId?: number;
  fileName: string;
  displayName?: string;
  s3Name: string;
  deleted: boolean;
  createdByUser: string | null;
  createdByDate: string;
  updatedByUser: string;
  updatedByDate: string;
  published: boolean;
  pinned?: boolean;
  reportingType?: string; // Only used for reporting documents
  size?: number; // Size in bytes
  type?: string; // Type of the document, e.g., 'pdf', 'docx'
  tags?: string[];
}

export type AIValidationStatus = '' | 'validated' | 'unvalidated';

export interface DocumentWithOtherData extends Document {
  policyExpirationDate: string;
  policyEffectiveYear: number;
  mainPolicyNumber: string;
  carrierName: string;
  accountName: string;
  carrierId: number;
  coverageType: string;
  aiValidationStatus?: AIValidationStatus;
  aiLinkedPromptResultId?: number | null;
  mappedPromptId?: number | null;
  mappedPromptVersion?: string | null;
}

export interface DocumentType {
  id: number;
  name: string;
  domainId: number;
  domainName: string;
  analyticsTypeId?: number;
}

export interface DocumentDomain {
  id: number;
  name: string;
}

export interface DocumentTag {
  id: number;
  name: string;
}

export interface UpdateDocumentRequest {
  documentDomainId?: number;
  documentSourceId?: number;
  documentTypeId?: number;
  accountId?: number;
  policyId?: number;
  rawName?: string;
  displayName?: string;
  s3Name?: string;
  deleted?: boolean;
  updatedByUser?: string;
  published?: boolean;
  tags?: string[];
}

export interface UploadDocumentRequest {
  domain: string;
  type: string;
  displayName?: string;
  fileName: string;
  accountId?: number;
  policyId?: number;
  analyticsTypeId?: number;
  document: File;
  tags?: string[];
}

export interface UploadDocumentResponse {
  success: boolean;
  messages: string[];
}

// temporary interface to deal with legacy Document objects
export interface PolicyFileMap {
  policy: EpicPolicy;
  file: File;
  type: DocumentType;
}
